export default "__VITE_ASSET__Jm3KosWv__"